import { Button, Col, Layout, Row, Spin, Tabs, Typography } from 'antd'
import { ScreenTitle } from 'components/ScreenTitle'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { dateFormatter } from '../../app/services/helper'
import { ErrorOutlineRounded } from '@mui/icons-material'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

interface ContentBoxNewProps {
  children: React.ReactNode
  title: string
  hasContent?: boolean
  isLoading?: boolean
  isError?: boolean
  errorMessage?: string
  handleClick?: () => void
  items?: any[]
  activeKey?: string
  shouldRenderChildren?: boolean
}

function ContentBoxNew({
  children,
  title,
  hasContent = true,
  isLoading = false,
  isError = false,
  errorMessage = 'Xəta baş verdi',
  handleClick,
  items,
  activeKey,
  shouldRenderChildren = false,
}: ContentBoxNewProps) {
  const history = useHistory()
  const { t } = useTranslation()

  const onClickRight = () => {
    window.location.reload()
  }
  
  const onClickLeft = () => {
    history.push('/')
  }

  const handleTabChange = (key: string) => {
    const selectedItem = items?.find((item) => item.key === key)
    if (selectedItem) {
      history.push(selectedItem.path)
    }
  }

  const renderContent = () => {
    if (isLoading) {
      return (
        <Row justify="center" align="middle" style={{ minHeight: 500 }}>
          <Spin size="large" />
        </Row>
      )
    }

    if (isError) {
      return (
        <Row
          justify="center"
          align="middle"
          style={{ gap: 20, minHeight: 500, flexDirection: 'column' }}
        >
          <ErrorOutlineRounded style={{ color: '#FF4E57', fontSize: 64 }} />
          <Typography.Text style={{ fontSize: 18 }}>
            {errorMessage}
          </Typography.Text>
          <Button type="link" onClick={onClickLeft}>
            {t('common.returnHome')}
          </Button>
        </Row>
      )
    }

    if (shouldRenderChildren) {
      return children
    }

    return (
      <Row justify="center" align="middle" style={{ minHeight: 500 }}>
        <Spin size='large' />
      </Row>
    )
  }

  return (
    <Row wrap style={{ flexDirection: 'column' }}>
      <Col span={24}>
        <ScreenTitle
          onClickRight={onClickRight}
          onClickLeft={onClickLeft}
          leftValue={title}
          rightValue={dateFormatter(new Date())}
        />
      </Col>
      <Col span={24}>
        <Tabs
          activeKey={activeKey}
          onChange={handleTabChange}
          className={styles.navbar}
          items={items}
        />
        <Layout.Content
          className={styles.responsive}
          {...(hasContent
            ? {
                style: {
                  backgroundColor: '#fff',
                  padding: 20,
                  borderRadius: items ? 0 : 10,
                },
              }
            : {})}
        >
          {renderContent()}
        </Layout.Content>
      </Col>
    </Row>
  )
}

export default ContentBoxNew